import * as Yup from 'yup';

const UpdateContactNumberSchema = Yup.object().shape({
    newContactNo1: Yup.string()
        .required('Mobile number is required.'),
    newContactNo2: Yup.string()
        .required('Mobile number is required.'),
    newContactNoCountryCode1: Yup.string()
        .required('Country code is required.'),
    newContactNoCountryCode2: Yup.string()
        .required('Country code is required.'),
});

export default UpdateContactNumberSchema;
